import { useEffect } from "react";
import { SITE } from "@/lib/site";

// Injects a JSON-LD script tag in <head>, replaced on data change, removed on unmount
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, data]);
  return null;
};

export const OrgJsonLd = () => (
  <JsonLd
    id="jsonld-organization"
    data={{
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE.name,
      legalName: SITE.legalName,
      url: window.location.origin,
      logo: `${window.location.origin}/logo.png`,
      email: SITE.email,
      telephone: SITE.phone,
      address: {
        "@type": "PostalAddress",
        streetAddress: SITE.address,
        addressLocality: "Grand Baie",
        addressCountry: "MU",
      },
      sameAs: Object.values(SITE.social),
      contactPoint: {
        "@type": "ContactPoint",
        telephone: SITE.phone,
        contactType: "customer service",
        availableLanguage: ["French", "English"],
      },
    }}
  />
);
